import moment from 'moment'

import { stringToDate } from 'modules/core/lib/dates'

import type Subscription from 'modules/billing/store/models/Subscription'

export const getTrialRemainingDays = (subscription: Subscription) => {
  if (!subscription.inCurrentFreeTrial) return 0

  const endDate = stringToDate(subscription.attributes.trial_end_date, 'backend')
  const now = moment()
  return endDate.diff(now, 'days') + 1
}
